import React from 'react';
import { ReactComponent as HWHorizontalLogo } from '../assets/hw_horizontal_logo.svg';
import { Box } from '@chakra-ui/react';

const NavBarLogo = (props) => {
  return <Box as={HWHorizontalLogo} {...props} />;
};

export default NavBarLogo;
